import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./product-branding.css"
import { Link } from 'react-router-dom';
import Arrow from "../../../assets/images/Services/right-arrow.png"


import img1 from "../../../assets/images/Services/Product-Brandining/branding-img-1.jpg"; // left image
import img2 from "../../../assets/images/Services/Product-Brandining/branding-img-2.jpg"; // right image


export default function ProductBrandining() {
    return (
        <div className='product-brand'>
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Product Branding</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to="/services">Services</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Product Branding</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section">
                <div className="branding-container">
                    {/* Images Section */}
                    <div className="branding-images">
                        <img src={img1} alt="branding" className="branding-img" />
                        <img src={img2} alt="branding" className="branding-img" />
                    </div>

                    {/* Content Section */}
                    <div className="branding-content">
                        <p className="intro">
                            At Horizon WebInfo Pvt Ltd, we understand that a powerful brand is the cornerstone of a successful online presence. Our comprehensive branding services are designed to elevate your business and create a lasting impression in the digital world.
                        </p>

                        {/* Sections */}
                        <section className='it-consult'>
                            <section className="branding-item">
                                <h4><img src={Arrow} />Crafting Your Identity</h4>
                                <p>
                                    We believe that a brand is more than just a logo or a color scheme. It's the essence of your business, reflecting its values, mission, and unique voice. Our team of experienced brand strategists collaborates closely with you to delve deep into your vision and values, ensuring that every element of your brand tells a compelling story.
                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />Brand Strategy</h4>
                                <p>
                                    A strong brand strategy is the roadmap to success. We meticulously analyze market trends, audience insights, and competitive landscapes to develop a customized strategy tailored specifically to your business. This strategy serves as the foundation for all branding efforts, ensuring consistency and resonance across every touchpoint.
                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />Visual Identity</h4>
                                <p>
                                    Our talented designers breathe life into your brand by creating visually captivating elements. From logos that encapsulate your identity to cohesive designs for websites, apps, and marketing materials, we ensure every visual aspect aligns seamlessly with your brand's personality.
                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />Brand Messaging</h4>
                                <p>
                                    Words have power. Our expert copywriters craft compelling brand messages and narratives that resonate with your audience. Whether it's website content, social media posts, or marketing campaigns, we ensure your brand communicates effectively and leaves a lasting impact.
                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />Brand Guidelines</h4>
                                <p>
                                    Consistency is key to a memorable brand. We develop comprehensive brand guidelines that serve as a playbook for your brand's usage. From typography and color palettes to voice and tone guidelines, these standards ensure that every interaction with your brand is cohesive and impactful.
                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />Brand Evolution</h4>
                                <p>
                                    As your business grows, so should your brand. We offer continuous support and refinement, adapting your brand strategy to align with evolving market trends and consumer behaviors. Our goal is to keep your brand fresh, relevant, and ahead of the curve.
                                </p>
                            </section>

                            {/* Why Choose Us */}
                            <section className="why-choose">
                                <h3>Why Choose Us</h3>
                                <ul>
                                    {/*<i aria-hidden="true" class="fas fa-plus-square"></i>*/}
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Our team comprises seasoned professionals dedicated to delivering top-tier branding solutions.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        We tailor our services to fit your unique business needs and goals.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        We believe in transparent communication and close collaboration throughout the process.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Our focus is on delivering tangible results that elevate your brand and drive growth.</li>
                                </ul>
                            </section>

                            {/* CTA */}
                            <section className="cta-section">
                                <h3>Let’s Bring Your Vision to Life</h3>
                                <p>
                                    Ready to take your brand to new heights? Contact us today to embark on a transformative branding journey with Horizon WebInfo Pvt Ltd.
                                </p>
                                <Link to="/get-a-quote" className="quote-btn1-brand">
                                    <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> GET A QUOTE</span>
                                </Link>
                            </section>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}